import { TIENDA, MENSAJE_COMPRA } from "../data/config";
import { useWhatsApp } from "../hooks/useWhatsApp";
import Boton from "./ui/Boton";
import IconoWhatsApp from "./ui/IconoWhatsApp";

const Hero = () => {
  const { abrirWhatsApp } = useWhatsApp();

  return (
    <section
      id="inicio"
      className="relative overflow-hidden bg-cream pt-28 pb-20 md:pt-40 md:pb-section"
    >
      {/*
        Grid de 1 columna en móvil y 2 en desktop.
        Orden en móvil (con order-*):  1=badge+título+desc  2=imagen  3=botones  4=indicadores
        Orden en desktop (lg:grid-cols-2): columna izquierda agrupa todo el texto,
        columna derecha la imagen — se logra colapsando los bloques 1/3/4 en la col-1
        y dejando el bloque 2 en la col-2 con lg:row-span-3.
      */}
      <div className="mx-auto grid max-w-container gap-x-16 gap-y-8 px-5 md:px-16 lg:grid-cols-2 lg:items-center lg:gap-y-0">

        {/* 1 — Badge + título + descripción */}
        <div className="animate-fade-in-up order-1 text-center lg:text-left">
          <span className="mb-6 inline-block rounded-full bg-peanut/20 px-5 py-2 text-xs font-semibold uppercase tracking-label text-secondary">
            100% Natural · Hecha en {TIENDA.ciudad}
          </span>

          <h1 className="font-literata text-4xl font-bold leading-tight tracking-tight text-charcoal md:text-5xl lg:text-6xl">
            La mejor mantequilla de maní{" "}
            <span className="text-forest">natural</span> del mundo
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-lg text-ink-variant lg:mx-0">
            Maní tostado, molido lento y sin atajos. Sin azúcar añadida, sin
            aceites ni conservantes. Solo el sabor puro del maní, directo del
            frasco a tu mesa.
          </p>
        </div>

        {/* 2 — Imagen: order-2 en móvil, columna derecha con row-span en desktop */}
        <div className="animate-fade-in-up relative order-2 lg:row-span-3 lg:order-none">
          <div className="overflow-hidden rounded-xl shadow-card">
            <img
              src="https://images.pexels.com/photos/8611766/pexels-photo-8611766.jpeg?auto=compress&cs=tinysrgb&w=1000"
              alt="Frasco de mantequilla de maní natural Agora apetitoso"
              className="h-full w-full object-cover"
              loading="eager"
            />
          </div>

          {/* Tarjeta flotante de precio: centrada en móvil, anclada a la izquierda desde sm */}
          <div className="absolute -bottom-6 left-4 rounded-xl border border-peanut/40 bg-white px-6 py-4 shadow-card sm:left-6 md:left-10">
            <p className="text-xs font-semibold uppercase tracking-label text-secondary">
              Desde
            </p>
            <p className="font-literata text-3xl font-bold text-charcoal">
              {TIENDA.precioFormateado}
            </p>
            <p className="text-sm text-ink-variant">Frasco de {TIENDA.peso}</p>
          </div>
        </div>

        {/* 3 — Botones (mt-8 en móvil despega de la tarjeta de precio flotante; lg:mt-10 separa de la descripción en desktop) */}
        <div className="order-3 mt-8 flex flex-col items-center gap-4 sm:flex-row lg:mt-10 lg:justify-start">
          <Boton
            variante="primario"
            className="w-full text-lg sm:w-auto"
            onClick={() => abrirWhatsApp(MENSAJE_COMPRA)}
          >
            <IconoWhatsApp className="text-2xl" />
            Comprar ahora
          </Boton>
          <a
            href="#producto"
            className="text-base font-semibold text-charcoal underline-offset-4 transition-colors hover:text-forest hover:underline"
          >
            Conoce el producto →
          </a>
        </div>

        {/* 4 — Mini-indicadores de confianza */}
        <ul className="order-4 flex flex-wrap items-center justify-center gap-3 text-sm text-ink-variant sm:gap-x-8 sm:gap-y-4 lg:mt-4 lg:justify-start">
          <li className="flex items-center gap-2 rounded-full bg-white/60 px-4 py-2 shadow-sm sm:bg-transparent sm:px-0 sm:py-0 sm:shadow-none">
            <span className="text-forest" aria-hidden="true">✓</span>
            Ingrediente único: maní
          </li>
          <li className="flex items-center gap-2 rounded-full bg-white/60 px-4 py-2 shadow-sm sm:bg-transparent sm:px-0 sm:py-0 sm:shadow-none">
            <span className="text-forest" aria-hidden="true">✓</span>
            Frasco de {TIENDA.peso}
          </li>
          <li className="flex items-center gap-2 rounded-full bg-white/60 px-4 py-2 shadow-sm sm:bg-transparent sm:px-0 sm:py-0 sm:shadow-none">
            <span className="text-forest" aria-hidden="true">✓</span>
            Envíos en {TIENDA.ciudad}
          </li>
        </ul>

      </div>
    </section>
  );
};

export default Hero;
